import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaBiddingsDistribution component.
 */
const FichaBiddingsDistribution = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Licitaciones.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>
          Selecciona el tipo de distribución que deseas para los datos, puede ser monto transado, número de licitaciones
          o número de órdenes de compra.
        </Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Gráfico tipo “Sankey”.</Item>
        <Item>Corresponde a la cifra general del organismo comprador.</Item>
        <Item>Corresponde a la distribución de datos entre las distintas licitaciones según su monto.</Item>
        <Item>
          Indicadores relevantes de las licitaciones del organismo comprador, al dar click podrás ver una tabla con el
          detalle de dicho indicador.
        </Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaBiddingsDistribution
